export const Museum = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 25H28" stroke="currentColor" stroke-width="2"/>
<path d="M2 29H30" stroke="currentColor" stroke-width="2"/>
<path d="M25 25V10" stroke="currentColor" stroke-width="2"/>
<path d="M19 25V10" stroke="currentColor" stroke-width="2"/>
<path d="M13 25V10" stroke="currentColor" stroke-width="2"/>
<path d="M7 25V10" stroke="currentColor" stroke-width="2"/>
<path d="M27 10H5V7L16 3L27 7V10Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
